export default __webpack_public_path__ + "static/media/planet-mars-internal.d867ac80.svg";